
export class EmployeeCodesRequest {
    employeeCodes: string[];
    username: string;

    /**
     * 
     * @param employeeCodes 
     * @param username 
     */
    constructor(employeeCodes: string[], username: string) {
        this.employeeCodes = employeeCodes;
        this.username = username;
    }
}